


























import { Prop, Component, Vue } from "vue-property-decorator";
import CMS from "@/general/components/CMS.vue";
@Component({
  name: "Z05Ranking",
  components: {
    CMS
  }
})
export default class Z05Ranking extends Vue {
  @Prop({ type: Number, default: 0 }) tab_id!: number;
}
